import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon, StandardLayout } from '@factorialco/f0-react'
import { AlertCircleLine } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export const MeetingErrorLayout = () => {
  return (
    <StandardLayout variant="narrow">
      <Box
        gap="s12"
        alignItems="center"
        justifyContent="center"
        position="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <F0Icon icon={AlertCircleLine} size="lg" color="critical" />
        <Text.Header3>{i18n.t('meetings.meeting.not_found_description')}</Text.Header3>
      </Box>
    </StandardLayout>
  )
}
